module.exports = __webpack_public_path__ + "img/icon-vanguards-le_fwt20.76c1c70.png";